// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  BillingOverlapPublicStatusDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class PublicOverlapStatusService {
  /**
   * GET /api/overlap-status
   */
  getStatus(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<BillingOverlapPublicStatusDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/overlap-status';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
